import React, { useState, useEffect } from "react";
import "../styles/CurvedContainer.css";

const CurvedContainer = ({ children }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 100); // petit délai pour déclencher l'animation proprement
  }, []);

  return (
    <div className="curve-wrapper">
      <div className={`curve-content ${loaded ? "flatten" : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default CurvedContainer;
